module.exports = __webpack_public_path__ + "img/my_build_edit_empty@2x.b89b0dc1.jpg";